module.exports = __webpack_public_path__ + "img/back-to-top.f42d1d42.svg";